import React, { Component } from "react";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ExploreSidebar from "./components/ExploreSidebar";

export default class ExploreVicePrincipal extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Explore BIT" image="banners/banner-explore.jpg" />

        {/* Main Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix py-5">
          <div className="container-xl">
            <div className="row">
              {/* Main Area */}
              <div className="col-lg-9 content-area order-lg-2">
                <div className="section-title text-left mb-4">
                  <h3 className="title">Principal</h3>
                </div>

                <section className="ttm-row team-details-section clearfix">
                  <div className="row align-items-center">
                    {/* Profile Image */}
                    <div className="col-lg-4 mb-4 mb-lg-0 text-center">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/explore/principaaal.jpeg"
                        }
                        alt="Principal"
                        className="img-fluid rounded shadow-sm"
                      />
                    </div>

                    {/* Intro Text */}
                    <div className="col-lg-8">
                      <div className="p-4 rounded bg-light shadow-sm">
                        <h2 className="fw-bold">Dr.Vijaya Prakash A M,</h2>
                        <p className="text-muted mb-2">
                          M.E, Ph.D., MISTE, FIE.
                        </p>
                        <hr />
                        <p className="text-justify">
                          Message from the Principal
                        </p>
                        <p className="text-justify">
                          As the Principal of Bangalore Institute of Technology,
                          it is my privilege to welcome you to our institution,
                          founded in 1979 by the Rajya Vokkaligara Sangha with a
                          strong commitment to values-based engineering
                          education, discipline, and social responsibility. Over
                          the decades, BIT has evolved into a distinguished
                          academic community, recognized for its academic rigor,
                          ethical foundation, and enriching learning
                          environment.
                        </p>
                        <p className="text-justify">
                          At Bangalore Institute of Technology, we regard
                          education as a holistic and transformative journey
                          that goes beyond the mere transfer of knowledge. Our
                          focus lies in nurturing innovation, integrity, and a
                          strong sense of responsibility toward society. In the
                          context of a rapidly changing global landscape, our
                          vision emphasizes sustainable development, innovation,
                          and the all-round growth of students. We strive to
                          foster an academic environment that encourages
                          curiosity, critical inquiry, and creative thinking.
                          Through outcome-based education, industry-aligned
                          curricula, state-of-the-art laboratories, smart
                          classrooms, and experiential learning practices, we
                          equip our students to emerge as competent
                          professionals, ethical leaders, and lifelong learners
                          prepared to face real-world challenges.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Full Text Content */}
                  <div className="col-lg-12 mt-5">
                    <p className="text-justify">
                      We remain steadfast in our efforts to strengthen academic
                      quality, skill enhancement, mentorship, and robust student
                      support systems, ensuring the comprehensive development,
                      safety, and well-being of every learner. The professional
                      involvement, dedication, and expertise of our faculty
                      across teaching, research, and academic activities reflect
                      the depth of knowledge and preparedness required to meet
                      the evolving demands of the technical world. We actively
                      cultivate a culture of collaboration, continuous
                      improvement, and professional development to collectively
                      propel BIT toward greater achievements.
                    </p>

                    <br />

                    <p className="text-justify">
                      Supported strongly by our management, alumni, and industry
                      partners, Bangalore Institute of Technology is steadily
                      evolving into a future-ready institution that is
                      innovation-driven, values-oriented, and socially
                      conscious. Together, we continue to build an ecosystem
                      where knowledge is aligned with purpose and tradition
                      seamlessly blends with modern technology.
                    </p>

                    <p className="text-justify">
                      I wish you a fulfilling, successful, and academically
                      rewarding student life at Bangalore Institute of
                      Technology. I am confident that you will contribute to
                      enhancing the pride and reputation of this esteemed
                      institution. We remain committed to sustaining the
                      excellence we have achieved and to continuously elevating
                      our standards across all dimensions of academic activity.
                      The Professional involvement of the staff in different
                      academic activities reflected the heights of knowledge to
                      meet the challenges in the technical world.
                    </p>

                    <div className="mt-4">
                      <p>Warm regards,</p>
                      <p className="fw-bold">
                        Dr.Vijaya Prakash A M, M.E, Ph.D., MISTE, FIE.
                      </p>
                      <p>Principal</p>
                      <p>Bangalore Institute of Technology</p>
                    </div>
                  </div>
                </section>
              </div>

              {/* Sidebar */}
              <div className="col-lg-3 widget-area">
                <ExploreSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
